import { Button } from "@chakra-ui/react"
import { MdClear } from "react-icons/md"

export default function FilterIndicator({filterName, displayFor, onClick, displayClearIcon = true}) {
  return(
    <>
      {displayFor && (
        <Button
          variant="outline"
          borderColor={'white'}
          color={'white'}
          borderWidth={'2px'}
          bg="transparent"
          onClick={onClick}
          borderRadius='full'
          px={3}
        >
          {displayClearIcon && <MdClear />}
          {filterName}
        </Button>
      )}
    </>
  )
}